var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLungWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 176.802,
    height: 126.415,
    viewBox: "0 0 176.802 126.415",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.498,
    y1: -0.153,
    x2: 1.518,
    y2: 1.26,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#098caf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09d785"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2353",
    "data-name": "Caminho 2353",
    d: "M139.779,68.969a18.973,18.973,0,0,0,2.159-9.148c-.019-4.811-.005-9.622,0-14.434a5.431,5.431,0,0,1,.029-.8,1.591,1.591,0,0,1,3.168.011,5.561,5.561,0,0,1,.027.8c0,4.838.011,9.676,0,14.515a18.754,18.754,0,0,0,2.206,9.135,1.646,1.646,0,0,0,2.819.572c2.806-2.318,5.662-2.278,8.313.176,3.391,3.14,6.916,6.158,10.089,9.507a46.755,46.755,0,0,1,12.459,24.564,52.136,52.136,0,0,1,.544,10.69,4.76,4.76,0,0,1-5.355,4.661c-5.944-.482-11.889-.967-17.823-1.57A11.061,11.061,0,0,1,148.4,106.58c-.053-7.579-.069-15.16.005-22.739a22.879,22.879,0,0,0-3.232-12.049,1.893,1.893,0,0,0-1.6-1.183c-.83-.014-1.277.529-1.668,1.2a22.41,22.41,0,0,0-3.219,12.05c.077,3.546.016,7.1.016,10.644q0,5.726,0,11.451c0,6.721-4.436,11.375-11.155,11.86-5.466.394-10.924.9-16.382,1.4a4.938,4.938,0,0,1-5.7-5.07,50.106,50.106,0,0,1,1.5-14.534,49.045,49.045,0,0,1,9.64-18.23c3.252-3.937,7.188-7.169,10.919-10.611a18.66,18.66,0,0,1,2.408-2.009,5.6,5.6,0,0,1,6.416.416c.17.132.332.273.5.41a2.237,2.237,0,0,0,1.374.613c.6,0,1.113-.413,1.544-1.225m2.713-28.927A4.838,4.838,0,0,0,138.713,45c-.014,5.106-.005,10.211,0,15.317a14.373,14.373,0,0,1-1.119,5.726c-.165-.074-.262-.113-.355-.161a8.849,8.849,0,0,0-10.7,1.43q-3.218,2.932-6.446,5.853a54.383,54.383,0,0,0-15.679,23.8,50.246,50.246,0,0,0-2.1,18.145,7.912,7.912,0,0,0,5.831,7.057c.354.1.7.211,1.056.318h2.258c1.572-.161,3.143-.334,4.717-.48,4.572-.424,9.171-.652,13.711-1.3A14.187,14.187,0,0,0,141.9,106.967c.113-5.882.032-11.767.036-17.651,0-2.123,0-4.245,0-6.368a17.1,17.1,0,0,1,1.358-6.661c.058-.137.131-.268.258-.525a16.253,16.253,0,0,1,1.571,6.217c.057,1.207.036,2.417.037,3.626,0,6.717.114,13.436-.028,20.151a14.83,14.83,0,0,0,14.478,15.3c5.2.27,10.383.853,15.574,1.3a2.666,2.666,0,0,1,.462.124H177.9c.527-.161,1.065-.292,1.579-.488a8.013,8.013,0,0,0,5.187-5.937c.042-.174.113-.34.17-.511v-7.581c-.052-.26-.12-.518-.154-.781-.186-1.464-.285-2.945-.558-4.393a50.42,50.42,0,0,0-13.437-25.944c-3.338-3.488-7.012-6.658-10.582-9.919a8,8,0,0,0-6.531-2.157,32.329,32.329,0,0,0-4.161,1.063,14.106,14.106,0,0,1-1.031-5.472q0-5.926,0-11.851c0-1.263.032-2.527-.011-3.788a4.837,4.837,0,0,0-4.795-4.8,4.988,4.988,0,0,0-1.088.121",
    transform: "translate(-102.22 -39.921)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2354",
    "data-name": "Caminho 2354",
    d: "M147.714,108.4a14.07,14.07,0,0,0-1.921.175,11.13,11.13,0,0,0-9.082,9.527,37.055,37.055,0,0,0,.169,5.375c.035.576-.151.783-.667.959-3.047,1.038-6.082,2.112-9.12,3.18a4.9,4.9,0,0,0-.884.381,1.572,1.572,0,0,0,.6,2.922,2.847,2.847,0,0,0,1.171-.207c2.462-.844,4.915-1.712,7.373-2.568.467-.163.94-.309,1.474-.483a26.424,26.424,0,0,1-2.612,9.416,1.007,1.007,0,0,1-.771.344c-1.177.016-2.354.016-3.532.015-.892,0-1.785,0-2.677.006a1.615,1.615,0,1,0-.035,3.205c.59.024,1.183.006,1.773.006h3.136c-.191.279-.268.416-.368.534-.862,1.029-1.735,2.049-2.589,3.085a1.611,1.611,0,1,0,2.43,2.086c1.233-1.414,2.429-2.86,3.684-4.345.275.357.583.755.888,1.156.846,1.111,1.672,2.239,2.544,3.33a1.293,1.293,0,0,0,1.646.481,2.264,2.264,0,0,0,1.086-1.238,2.234,2.234,0,0,0-.485-1.526c-1.163-1.644-2.388-3.246-3.622-4.839a.9.9,0,0,1-.113-1.083,17.7,17.7,0,0,0,1.061-2.519c.661-2.226,1.244-4.476,1.875-6.777,1.341,1.248,2.715,2.528,4.091,3.806.355.328.7.676,1.078.97a1.549,1.549,0,0,0,2.186-.084,1.582,1.582,0,0,0-.024-2.25,7.212,7.212,0,0,0-.577-.561c-2.063-1.926-4.142-3.836-6.175-5.792a2.244,2.244,0,0,1-.588-1.23c-.156-1.088-.167-2.2-.295-3.289a8,8,0,0,1,5.748-8.621c.767-.213,1.586-.24,2.376-.378a1.6,1.6,0,0,0,1.463-1.713,1.564,1.564,0,0,0-1.676-1.457h-.034",
    transform: "translate(-125.405 -108.399)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2355",
    "data-name": "Caminho 2355",
    d: "M207.726,108.4a1.573,1.573,0,0,0-.284,3.121,4.522,4.522,0,0,0,.8.1,8.1,8.1,0,0,1,7.232,5.732c.489,1.678.107,3.354.128,5.031a4.571,4.571,0,0,1-1.876,3.814c-1.84,1.566-3.561,3.272-5.324,4.926a1.7,1.7,0,0,0-.632,2.069,1.608,1.608,0,0,0,2.681.411c1.282-1.146,2.522-2.337,3.783-3.507.425-.394.858-.781,1.39-1.264a32.029,32.029,0,0,0,2.837,9.734.96.96,0,0,1-.2.759c-.964,1.325-1.963,2.624-2.942,3.937a13.558,13.558,0,0,0-1.055,1.517,1.512,1.512,0,0,0,.44,1.945,1.56,1.56,0,0,0,2-.075,5.343,5.343,0,0,0,.687-.785c.987-1.3,1.964-2.6,2.986-3.961.413.56.739,1.051,1.114,1.5.857,1.032,1.723,2.058,2.616,3.06a1.375,1.375,0,0,0,1.729.464,2.135,2.135,0,0,0,1.035-1.27,2.417,2.417,0,0,0-.611-1.554c-.867-1.12-1.83-2.167-2.754-3.243l.1-.205h.868c.4,0,.8,0,1.2,0,.945.006,1.889.011,2.833-.018a1.617,1.617,0,0,0,1.671-1.613,1.649,1.649,0,0,0-1.693-1.594c-.214-.012-.43,0-.644,0l-1.415,0c-1.436,0-2.872.006-4.308-.023a1.015,1.015,0,0,1-.782-.436,41.38,41.38,0,0,1-1.706-4.508c-.443-1.553-.653-3.173-.992-4.9,2.405.841,4.6,1.617,6.809,2.379.937.324,1.871.669,2.829.914a1.487,1.487,0,0,0,1.791-.991,1.535,1.535,0,0,0-.737-1.922,5.027,5.027,0,0,0-.813-.342q-4.024-1.411-8.052-2.813c-1.922-.672-1.916-.674-1.627-2.746.7-4.995-.793-9.074-5.089-11.921a10.307,10.307,0,0,0-5.8-1.73l-.226,0",
    transform: "translate(-206.151 -108.395)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2356",
    "data-name": "Caminho 2356",
    d: "M10.73,121.182c-4.214,0-5.546-1.352-5.546-5.6q0-52.39,0-104.78c0-4.176,1.425-5.622,5.559-5.622q77.7,0,155.39,0c4.019,0,5.485,1.483,5.485,5.526q0,52.477,0,104.953c0,4.124-1.372,5.52-5.451,5.522q-17.179.008-34.358.009a12.9,12.9,0,0,0-1.355.052H50.485a11.654,11.654,0,0,0-1.6-.055q-19.078-.007-38.157-.005M9.912.007a9.413,9.413,0,0,0-9.184,5.8C.468,6.37.242,6.944,0,7.511V118.68c2.1,6.508,6.365,7.8,11.472,7.733,9.551-.123,19.1-.088,28.655-.066v.068h96.659v-.054q14.988.006,29.977-.006c6.157-.012,10.034-3.9,10.036-10.025q.01-53.081,0-106.162a12.765,12.765,0,0,0-.163-2.4C175.691,2.9,171.909,0,166.511,0Q100.988,0,35.465,0L20.559,0Q15.235,0,9.912.007",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2357",
    "data-name": "Caminho 2357",
    d: "M25.987,22.458c-2.662.017-3.516.876-3.518,3.526-.006,8.284.021,16.568-.015,24.852a9.14,9.14,0,0,0,3.089,7.012,5.346,5.346,0,0,1,1.613,3.388q.188,14.754,0,29.511a5.021,5.021,0,0,1-1.544,3.247,9.083,9.083,0,0,0-3.162,7.149c.041,7.766.011,15.533.015,23.3,0,2.842.76,3.628,3.531,3.629q13.112.006,26.225,0h5.995c.113,0,.225,0,.338,0h84.3c.169,0,.338,0,.507,0h5.524q12.962,0,25.924,0c3.012,0,3.722-.726,3.722-3.786q0-49.018,0-98.038c0-3-.779-3.792-3.776-3.792q-63.357,0-126.716,0a7.565,7.565,0,0,0-1.712.135A2.388,2.388,0,0,0,44.3,25.209,2.371,2.371,0,0,0,46.58,27.6a21.477,21.477,0,0,0,2.242.058q61.027,0,122.054,0h2.36V122.9h-2.151q-11.1,0-22.2.006v0h-5.519c-.205-.005-.413-.007-.618,0H52.223v0q-11.256-.006-22.512-.006H27.656c0-7.649-.042-15.008.058-22.365a3.8,3.8,0,0,1,1.3-2.456,9.485,9.485,0,0,0,3.408-7.6q-.014-14.5,0-28.995a9.512,9.512,0,0,0-3.365-7.615,3.829,3.829,0,0,1-1.338-2.435c-.1-7.82-.06-15.641-.06-23.777,2.531,0,4.877.01,7.223,0s3.507-.9,3.478-2.624-1.189-2.564-3.568-2.574q-2.347-.01-4.694-.011-2.055,0-4.11.012",
    transform: "translate(-22.453 -22.446)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2358",
    "data-name": "Caminho 2358",
    d: "M52.893,224.247a1.027,1.027,0,0,1-.661.332c-.486.023-.974.02-1.461.018-.36,0-.72,0-1.078,0a1,1,0,0,0-1.071,1,1.015,1.015,0,0,0,1.038,1.048c.456.03.915.006,1.373.006v.005c.183,0,.367.014.549,0a1.672,1.672,0,0,1,1.647.641,2.055,2.055,0,0,0,2.858.248,3.239,3.239,0,0,1,1.595-.884h59.869l1.35,0v0h59.22q2.137,0,4.274-.007c.785,0,1.246-.433,1.222-1.08-.023-.628-.45-.979-1.234-.983-1.421-.007-2.842,0-4.263,0q-1.535,0-3.07,0h-57.5q-1.535,0-3.07,0H57.553a.932.932,0,0,1-.1-.013,1.367,1.367,0,0,1-.72-.353,2.492,2.492,0,0,0-1.9-.969,2.544,2.544,0,0,0-1.935.988",
    transform: "translate(-48.622 -223.259)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-lung-white",
    transform: "translate(-678.404 -2115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4990",
    "data-name": "Grupo 4990",
    transform: "translate(725.551 2133.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4989",
    "data-name": "Grupo 4989",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2288",
    "data-name": "Ret\\xE2ngulo 2288",
    width: 82.839,
    height: 82.562,
    transform: "translate(-0.22 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4992",
    "data-name": "Grupo 4992",
    transform: "translate(736.244 2164.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4991",
    "data-name": "Grupo 4991",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2289",
    "data-name": "Ret\\xE2ngulo 2289",
    width: 24.174,
    height: 38.911,
    transform: "translate(-0.088 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4994",
    "data-name": "Grupo 4994",
    transform: "translate(773.485 2164.994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4993",
    "data-name": "Grupo 4993",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2290",
    "data-name": "Ret\\xE2ngulo 2290",
    width: 24.258,
    height: 38.893,
    transform: "translate(-0.066 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-lung",
    transform: "translate(678.404 2115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4995",
    "data-name": "Grupo 4995",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2291",
    "data-name": "Ret\\xE2ngulo 2291",
    width: 176.805,
    height: 126.479,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4998",
    "data-name": "Grupo 4998",
    transform: "translate(688.76 2125.353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4997",
    "data-name": "Grupo 4997",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2292",
    "data-name": "Ret\\xE2ngulo 2292",
    width: 156.092,
    height: 105.629,
    transform: "translate(-0.015)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5000",
    "data-name": "Grupo 5000",
    transform: "translate(700.83 2217.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4999",
    "data-name": "Grupo 4999",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2293",
    "data-name": "Ret\\xE2ngulo 2293",
    width: 135.028,
    height: 5.014,
    transform: "translate(-0.008)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLungWhite);
export default __webpack_public_path__ + "static/media/icon-lung-white.6340d864d27f76609b349fdc508a8422.svg";
export { ForwardRef as ReactComponent };